import { atom } from 'nanostores'

import type { CountryCode } from '@/services/schemas'

const $country = atom<CountryCode | null>(null)

export {
  $country,
}
